import { type RootContainerProps } from "@client/content/types";
import { type AppState } from "@client/types";
import { connect } from "react-redux";
import { makeGridListPropsSelector } from "../selectors";
import Component, { type MapProps } from "./component";

const makeMapStateToProps = () => {
  const gridPropsSelector = makeGridListPropsSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const gridProps = gridPropsSelector(state, props);

    return {
      ...props,
      gridProps
    };
  };
};

export default connect(makeMapStateToProps)(Component);
